import React, { useState } from 'react';
import {AddCreditCardForm} from './addCreditCardForm';
import {AddVirementForm} from './addVirementForm';
import * as Loadings from '../../../constants/loadings/user';
import onlinePaymentIcon from '../../../assets/images/svg/053-online-payment.svg';
import creditCardsIcon from '../../../assets/images/svg/053-credit-cards.svg';
import * as R from 'ramda';



export const AddPaymentMethodModal = ({ user, loadings }) => {
	let formReference = React.createRef();
	const [tempSelectedOptionCard, setTempSelectedOptionCard] = useState(undefined);
	const [selectedOptionCard, setSelectedOptionCard] = useState(undefined);
	const [isSaving, setIsSaving] = useState(false);
	const [ownerState, setOwnerState] = useState({
		name: `${user.firstName} ${user.lastName}`,
		email: `${user.email}`
	});
	const formId = "FormId";

	function resetModal(){
		setTempSelectedOptionCard(undefined);
		setSelectedOptionCard(undefined);
	}
    return (
		<div className="modal fade px-0" id="payment" aria-labelledby="payment" aria-hidden="true">
			<div className="modal-dialog px-2">
				<div className="modal-content">
					<header className="modal-header pb-0">
						<div className="alert bg-alert-secondary rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
							<h1 className="sr-only visually-hidden">Avatar</h1>
							<div className="flex-row align-items-center justify-content-between">
								<div className="h4 text-secondary text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="paymentLabel">Configurer une méthode de paiement</div>
								<button type="button" className="btn btn-close btn-icon p-0 mr-0 o-60 o-100--hover" data-dismiss="modal" aria-label="Close">
									<i className="eva eva-close fs-4 lh-root"></i>
								</button>
							</div>
						</div>
					</header>
					<div className="modal-body text-left">
						{R.isNil(selectedOptionCard) ?
							<form className="grid grid-2">
								<div className="form-group my-auto">
									<div className={"card py-4 text-center picker-card" + ((tempSelectedOptionCard === "card") ? " active" : "")} onClick={(e) => { e.preventDefault(); setTempSelectedOptionCard('card')}}>
										<img className="img-fluid mx-auto my-3 mb-2 h-6" src={creditCardsIcon} alt="crédit" />
										<h2 className="h5 text-uppercase font-weight-bolder my-auto pb-4" >carte de crédit</h2>
									</div>
								</div>
								<div className="form-group my-auto">
									<div className={"card py-4 text-center picker-card" + ((tempSelectedOptionCard === "sepa_debit") ? " active" : "")} onClick={(e) => { e.preventDefault(); setTempSelectedOptionCard('sepa_debit') }}>
										<img className="img-fluid mx-auto my-3 mb-2 h-6" src={onlinePaymentIcon} alt="virement" />
										<h2 className="h5 text-uppercase font-weight-bolder my-auto pb-4">virement</h2>
									</div>
								</div>
							</form>
							: ''
						}
						{
							(selectedOptionCard === "card") ? <AddCreditCardForm ownerState={ownerState} setOwnerState={setOwnerState} formRef={formReference} user={user} formId={formId} resetModal={resetModal} setIsSaving={setIsSaving} /> : ""
						}
						{
							(selectedOptionCard === "sepa_debit") ? <AddVirementForm ownerState={ownerState} setOwnerState={setOwnerState} formRef={formReference} user={user} formId={formId} resetModal={resetModal} setIsSaving={setIsSaving} /> : ""
						}
						
					</div>
					<div className="modal-footer bg-light py-3">
						{/* {
							R.isNil(paymentMethod) ?
								''
								:
								!R.isNil(loadings) && loadings.includes(Loadings.DELETING_PAYMENTMETHOD) ?
									<button type="button" className="btn btn-alert-danger border-none px-3 mr-auto" disabled><i className="eva eva-trash-outline mr-2 align-middle" ></i>Supprimer</button>
									:
									<button type="button" className="btn btn-alert-danger border-none px-3 mr-auto"
										onClick={
											async (e) => {
												e.preventDefault();
												await dispatch(removePaymentMethod(user, paymentMethod));
											}
										}><i className="eva eva-trash-outline mr-2 align-middle" ></i>Supprimer</button>
						} */}
						<button type="button" className="btn btn-light px-3 mr-auto" data-dismiss="modal">Annuler</button>
						{!R.isNil(selectedOptionCard) ?
							<button type="button" className={"btn" + (R.isNil(user.paymentMethod) ? ' px-3 mr-2 btn-white-dark text-dark' : ' btn-dark')} onClick={(e) => { e.preventDefault(); setSelectedOptionCard(undefined); setTempSelectedOptionCard(undefined) }}><i className={"eva eva-arrow-back align-middle fs-root lh-1 mr-2" + (R.isNil(user.paymentMethod) ? '' : ' d-none')}></i>Retour</button>
							: ''
						}
						{
							R.isNil(user.paymentMethod) ?
								!R.isNil(loadings) && loadings.includes(Loadings.ADDING_PAYMENTMETHOD) ?
									<button type="submit" className="btn btn-secondary" disabled>{R.isNil(selectedOptionCard) ? 'Choisir' : 'Ajouter'}</button>
									:
									R.isNil(selectedOptionCard) ?
											<button type="submit" className="btn btn-secondary" onClick={(e) => { e.preventDefault(); setSelectedOptionCard(tempSelectedOptionCard) }}>Choisir</button>
										:
										R.isNil(user.paymentMethod) ?
											(!R.isNil(loadings) && loadings.includes(Loadings.ADDING_PAYMENTMETHOD)) || isSaving ?
													<button type="submit" className="btn btn-secondary loading-btn show" ><div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>Ajouter</button>
												:
												<button type="submit" className="btn btn-secondary loading-btn" form={formId}><div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>Ajouter</button>
											:
											<button type="submit" className="btn btn-secondary" disabled>Ajouter</button>
							:
								<button type="submit" className="btn btn-secondary" disabled>{R.isNil(selectedOptionCard) ? 'Choisir' : 'Ajouter'}</button>
						}
					</div>
				</div>
			</div>
		</div>
	)

}